/**
 * Native NgRx feature for the advocacy-group section — WS2 strangle of the
 * AngularJS `AccountApp.v2.GroupAdvocacy` ng-redux module.
 *
 * The four view reducers (guestsJourneys/bigPicture/audiences/contests) AND the
 * seven advocacy `apiData` reducers (the data the components actually render) are
 * REUSED VERBATIM here — they are plain redux reducers `(state, {type, payload})`,
 * which are valid NgRx `ActionReducer`s. They key off the same action-type string
 * constants the thunks dispatch, so the existing thunk logic (run through the
 * facade's thunk-dispatch adapter, see advocacy-ngredux.facade.ts) drives them
 * unchanged. `runtimeChecks` immutability is OFF (app.module StoreModule.forRoot),
 * so the bigPicture in-place mutation is tolerated as-is.
 *
 * These imports still point at account-v2 (the files move into this store/ dir in
 * the cleanup commit that deletes the AngularJS GroupAdvocacy module).
 */
import { ActionReducer, ActionReducerMap } from '@ngrx/store';

// 4 view reducers (were state.views.*)
import guestsJourneys from '../../../../account-v2/src/app/features/advocacy/group/journeys/reducers';
import bigPicture from '../../../../account-v2/src/app/features/advocacy/group/big-picture/reducers';
import contests from '../../../../account-v2/src/app/features/advocacy/group/contests/reducers';
import audiences from '../../../../account-v2/src/app/features/advocacy/group/audiences/reducers';

// 7 advocacy apiData reducers (were state.apiData.*) — only the advocacy section
// reads these (verified: no editor/curation/other-feature store readers).
import propertyGuestsJourneys from '../../../../account-v2/src/app/reducers/api-data/propertyGuestsJourneys';
import propertyAdvocacyOverview from '../../../../account-v2/src/app/reducers/api-data/propertyAdvocacyOverview';
import propertyAdvocacyImpact from '../../../../account-v2/src/app/reducers/api-data/propertyAdvocacyImpact';
import propertyPlatformData from '../../../../account-v2/src/app/reducers/api-data/propertyPlatformData';
import prestay from '../../../../account-v2/src/app/reducers/api-data/prestay';
import poststay from '../../../../account-v2/src/app/reducers/api-data/poststay';
import photoAdvocacy from '../../../../account-v2/src/app/reducers/api-data/photoAdvocacy';

export const ADVOCACY_GROUP_FEATURE = 'advocacyGroup';

export interface AdvocacyGroupState {
  // view slices
  guestsJourneys: any;
  bigPicture: any;
  audiences: any;
  contests: any;
  // apiData slices
  propertyGuestsJourneys: any;
  propertyAdvocacyOverview: any;
  propertyAdvocacyImpact: any;
  propertyPlatformData: any;
  prestay: any;
  poststay: any;
  photoAdvocacy: any;
}

// The plain redux reducers are NgRx-compatible ActionReducers; cast to satisfy
// the ActionReducerMap action-type generic.
export const advocacyGroupReducers: ActionReducerMap<AdvocacyGroupState> = {
  guestsJourneys: guestsJourneys as ActionReducer<any>,
  bigPicture: bigPicture as ActionReducer<any>,
  audiences: audiences as ActionReducer<any>,
  contests: contests as ActionReducer<any>,
  propertyGuestsJourneys: propertyGuestsJourneys as ActionReducer<any>,
  propertyAdvocacyOverview: propertyAdvocacyOverview as ActionReducer<any>,
  propertyAdvocacyImpact: propertyAdvocacyImpact as ActionReducer<any>,
  propertyPlatformData: propertyPlatformData as ActionReducer<any>,
  prestay: prestay as ActionReducer<any>,
  poststay: poststay as ActionReducer<any>,
  photoAdvocacy: photoAdvocacy as ActionReducer<any>,
};
